import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-flipbook',
  templateUrl: './flipbook.component.html',
  styleUrls: ['./flipbook.component.scss']
})
export class FlipbookComponent {
  @Input() pdfUrl: string = '';
  @Input() name: string = '';

  get flipbookSrc(): string {
    if (!this.pdfUrl) return '';
    return 'https://admin.blackrockgames.fr/api/flipbook.php?url=' + encodeURIComponent(this.pdfUrl);
  }
}
